/**
 * Component Registry for The Heights at Happy Valley
 * 
 * Inherits from @vibesites-cobalt/theme-theme-avenue and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-cobalt/theme-theme-avenue/registry';
import './heading-font.css';
import { AmenitiesList } from './components/AmenitiesList';
import { CommercialDetails } from './components/CommercialDetails';
import { CommercialHero } from './components/CommercialHero';
import { FloorplansList } from './components/FloorplansList';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { LiveWorkUnits } from './components/LiveWorkUnits';
import { PageBlurb } from './components/PageBlurb';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';
import { VirtualTourEmbed } from './components/VirtualTourEmbed';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  CommercialDetails,
  CommercialHero,
  LiveWorkUnits,
  FloorplansList,
  Footer,
  Header,
  Hero,
  PageBlurb,
  SpecialOfferBanner,
  VirtualTourEmbed,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
